import styled from 'styled-components'
import * as BaseStyles from '../BaseStyles'

import logoIcon from '../../Icons/Logos/qf-logo.png'

export const SignUpDiv = styled(BaseStyles.Div)`
    padding: 2rem;
    width:  100vw;
    height: 100vh;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const SignUpComponentsDiv = styled(BaseStyles.Div)`
    box-shadow:
    0 0px 3.8px rgba(0, 0, 0, 0.022),
    0 0px 8.3px rgba(0, 0, 0, 0.031),
    0 0px 14.9px rgba(0, 0, 0, 0.039),
    0 0px 30.5px rgba(0, 0, 0, 0.048),
    0 0px 104px rgba(0, 0, 0, 0.07)
    ;
    margin: auto;
    flex: 1 1 50rem;
    min-width: 30rem;
    max-width: 50rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.8rem;
    background-color: white;
    padding: 0.75%;
`

export const QuickFillerButtonDiv = styled(BaseStyles.Div)`
    margin-bottom: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const SignUpFieldsDiv = styled(BaseStyles.Div)`
    padding: 6rem 2rem;
    width: 100%;
`

export const SignUpFormDiv = styled(BaseStyles.Div)`
    margin: 0rem 2rem;
`

export const SignUpButtonDiv = styled(BaseStyles.Div)`
    margin-top: 3rem;
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const QuestionDiv = styled(BaseStyles.Div)`
    margin-top: 2rem;
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const SignInButtonDiv = styled(BaseStyles.Div)`
    margin-top: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const TitleIconButton = styled(BaseStyles.IconButton)`
    margin-right: 0.5rem;
    padding: 0;
    width: 3rem;
    height: 3rem;
    background-image: url(${logoIcon});
`

export const QuickFillerButton = styled.button`
    margin: 0;
    padding: 0;
    color: black;
    background-color: transparent;
    outline-style: none;
    cursor: pointer;
    font-size: 3rem;
    line-height: 3rem;
    border: none;
    font-weight: bold;
    font-family: "Helvetica Neue";
    &:hover {
        color: #4267B2;
    }
`

export const SignUpTitle = styled.h2`  
    margin: 0;
    padding: 0rem;
    padding-bottom: 3.5rem;
    font-size: 2.5rem;
    font-weight: 550;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
`

export const SignUpRowDiv = styled(BaseStyles.Div)`
    width: 100%;
    overflow: hidden;
    padding: 0.2rem 0rem;
`

export const FullSignUpDiv = styled(BaseStyles.Div)`
    width: 100%;
    display: inline-block;
`

export const SignUpHeader = styled.p`
    margin: 0;
    padding: 0;
    margin-bottom: 0.4rem;
    font-size: 1.2rem;
    font-weight: 450;
`

export const SignUpInputField = styled(BaseStyles.InputField)`
    font-size: 1.65rem;
    height: 3rem;
    width: 100%;
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
    padding: 0rem 0.2rem; 
`

export const ActionButton = styled.button`
    wmargin: 0;
    padding: 0;
    width: 40%;
    height: 3rem;
    font-size: 1.8rem;
    color: black;
    outline-styles: none;
    border-radius: 0.7rem;
    border-style: solid;
    border-width: thin;
    cursor: pointer;
`

export const SignUpButton = styled(ActionButton)`
    background-color: transparent;
    border-color: #4267B2;
    &:hover{
        background-color: #4267B2;
        color: white;
    }
`

export const SignInButton = styled(ActionButton)`
    background-color: transparent;
    border-color: #383838;
    &:hover{
        background-color: #383838;
        color: white;
    }
`

export const QuestionPhrase = styled.h5`
    margin: 0;
    padding: 0;
    font-size: 1.4rem;
    font-weight: normal;
`